import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "./MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const rowsTotal = (rows) =>
  (rows || []).reduce(
    (sum, item) =>
      sum + Number(item?.playerPL),
    0,
  );

const AWCcasinoProfitLoss = () => {
  const params = useParams();
  const tableRef = useRef();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    type: "3",
    betType: "casino",
    sortOrder: "asc",
    casionType: -1,
    userType: params.type,
    id: params.id,
    status: "completed",
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
  };

  const [data, setData] = useState([]);
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [openRows, setOpenRows] = useState({});

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getCasinoNew,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      if (response_users.results?.data?.length > 0) {
        setData(response_users.results);
      } else {
        setData(response_users.results || []);
      }
    }
  };

  useEffect(() => {
    getData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, filter.limit]);

  const handleLimitChange = (e) => {
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const applyPreset = (preset) => {
    const fromPeriod =
      preset === "today"
        ? moment().startOf("day")
        : moment().subtract(1, "day").startOf("day");
    const toPeriod =
      preset === "today"
        ? moment().endOf("day")
        : moment().subtract(1, "day").endOf("day");
    const nextFilter = {
      ...filter,
      page: 1,
      fromPeriod: fromPeriod.format("YYYY-MM-DD HH:mm:ss"),
      toPeriod: toPeriod.format("YYYY-MM-DD HH:mm:ss"),
    };
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const toggleRow = (id) =>
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));

  const redirectCasino = async (userId, platform, platformTxId, type) => {
    const { status, data: response_users } = await apiGet(
      apiPath.casinoWalletHistory +
        "?userId=" +
        userId +
        "&platform=" +
        platform +
        "&platformTxId=" +
        platformTxId,
    );
    if (status === 200 && response_users.status) {
      if (response_users.data?.status === "0000") {
        const url =
          type === 1 ? response_users.data?.txnUrl : response_users.data?.url;
        window.open(url, "_blank", "height=900,width=1200");
      } else {
        toast.error(response_users.data.desc);
      }
    } else {
      toast.error(response_users?.data?.desc);
    }
  };

  const rows = data?.data || [];
  const totalPL = rowsTotal(rows);

  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <h3
          style={{ fontSize: "24px", marginTop: "20px", marginBottom: "10px" }}
        >
          AWC Casino Profit &amp; Loss
        </h3>

        <div className="function-wrap">
          <ul className="input-list">
            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
          </ul>

          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>

        <ul className="input-list flowroot">
          <li id="totalPL" style={{ fontSize: "15px", fontWeight: "700" }}>
            Total P/L:{" "}
            <span
              className={totalPL < 0 ? "red" : "green"}
              style={{ fontSize: "15px", fontWeight: "700" }}
            >
              {totalPL < 0
                ? `(${toFixedWithoutRounding(Math.abs(totalPL))})`
                : toFixedWithoutRounding(totalPL)}
            </span>
          </li>
          <li className="spacer" />
          <li>
            <span>
              <label>Last:</label>
              <select
                name="limit"
                id="limit"
                value={filter.limit}
                onChange={handleLimitChange}
              >
                <option value={10}>10 Txn</option>{" "}
                <option value={25}>25 Txn</option>{" "}
                <option value={50}>50 Txn</option>
                <option value={100}>100 Txn</option>
              </select>
            </span>
          </li>
          <li>
            <MyAccountFilter
              type="new"
              tableRef={tableRef}
              fileName="awc-casino-profitLoss"
            />
          </li>
        </ul>

        <div id="reportTable">
          <div
            className="table-responsive data-table"
            style={{ overflow: "auto", whiteSpace: "nowrap" }}
          >
            <table
              ref={tableRef}
              id="table_DL"
              className="table01 table-pnl"
              style={{ display: "table" }}
            >
              <tbody>
                <tr>
                  <th className="align-L sort_asc">Market</th>
                  <th width="15%" className="sort_asc">
                    Settled date
                  </th>
                  <th width="18%" className="sort_asc">
                    Profit/Loss
                  </th>
                </tr>

                {rows && rows.length > 0 ? (
                  rows.map((item, index) => {
                    const rowId = item?.platformTxId || index;
                    const isOpen = !!openRows[rowId];
                    const pl = Number(item?.playerPL);

                    return (
                      <React.Fragment key={rowId}>
                        <tr style={{ display: "table-row" }}>
                          <td id="title" className="align-L">
                            {item?.casinoType || "CASINO"}
                            <img
                              src="/assets/images/transparent.gif"
                              className="fromto"
                              alt=""
                            />
                            <strong>{item?.gameType || "TABLE"}</strong>
                            <img
                              src="/assets/images/transparent.gif"
                              className="fromto"
                              alt=""
                            />
                            {item?.casinoName}
                          </td>
                          <td id="settledDate">
                            {formatDate(item?.timeInserted, user?.timeZone)}
                          </td>
                          <td>
                            <a
                              onClick={() => toggleRow(rowId)}
                              className={
                                !isOpen ? "expand-close" : "expand-open"
                              }
                            >
                              {Math.sign(pl) === -1 ? (
                                <span className="red">
                                  ({toFixedWithoutRounding(Math.abs(pl))})
                                </span>
                              ) : (
                                <span className="green">
                                  {toFixedWithoutRounding(pl)}
                                </span>
                              )}
                            </a>
                          </td>
                        </tr>

                        <tr
                          className="expand"
                          id={`sub_${rowId}`}
                          style={{ display: isOpen ? "table-row" : "none" }}
                        >
                          <td colSpan={3}>
                            <img
                              src="/assets/images/transparent.gif"
                              className="expand-arrow-R"
                              alt=""
                            />
                            <table className="table-commission">
                              <tbody>
                                <tr>
                                  <th width="12%" className="sort_asc">
                                    Bet ID
                                  </th>
                                  <th width="13%" className="sort_asc">
                                    Stake
                                  </th>
                                  <th width="20%">Bet Placed</th>
                                  <th width="23%" className="sort_asc">
                                    Profit/Loss
                                  </th>
                                </tr>
                                <tr
                                  className="even"
                                  style={{ display: "table-row" }}
                                >
                                  <td id="betID">
                                    <a
                                      onClick={() =>
                                        redirectCasino(
                                          item?.clientName,
                                          item?.platform,
                                          item?.platformTxId,
                                          1,
                                        )
                                      }
                                    >
                                      {item?.platformTxId}
                                    </a>
                                  </td>
                                  <td id="txStake">
                                    {toFixedWithoutRounding(item?.betAmount)}
                                  </td>
                                  <td id="placed">
                                    {formatDate(
                                      item?.timeInserted,
                                      user?.timeZone,
                                    )}
                                  </td>
                                  <td
                                    id="txLiability"
                                    className={
                                      pl < 0 ? "loss-text" : "win-text"
                                    }
                                  >
                                    {toFixedWithoutRounding(pl)}
                                  </td>
                                </tr>

                                <tr className="sum-pl">
                                  <td colSpan={7}>
                                    <dl>
                                      <dt>Total Stakes</dt>
                                      <dd>
                                        {toFixedWithoutRounding(
                                          item?.betAmount,
                                        )}
                                      </dd>{" "}
                                      <dt>Back subtotal</dt>
                                      <dd>0.00</dd> <dt>Lay subtotal</dt>
                                      <dd>0.00</dd>
                                      <dt>Market subtotal</dt>
                                      <dd className={pl < 0 ? "red" : "green"}>
                                        {toFixedWithoutRounding(Math.abs(pl))}
                                      </dd>
                                      <dt className="net_total">
                                        Net Market Total
                                      </dt>
                                      <dd
                                        className={`net_total ${pl < 0 ? "red" : "green"}`}
                                      >
                                        {pl < 0
                                          ? `(${toFixedWithoutRounding(Math.abs(pl))})`
                                          : toFixedWithoutRounding(pl)}
                                      </dd>
                                    </dl>
                                    <a
                                      style={{ padding:"10px" }}
                                      onClick={() =>
                                        redirectCasino(
                                          item?.clientName,
                                          item?.platform,
                                          item?.platformTxId,
                                          2,
                                        )
                                      }
                                    >
                                      Get Result
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={3}>You have no bets in this time period.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="bottom-pagination">
            {rows.length > 0 && data?.totalDocs > 0 && (
              <Pagination pagination={data} onPageChange={handlePageChange} />
            )}
          </div>
        </div>

        <p className="table-other">
          Profit and Loss is shown net of commission.
        </p>
      </div>
    </MyAccountLayout>
  );
};

export default AWCcasinoProfitLoss;
